import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {IMenuStore} from "../../mobx-store/storeInterfaces/menuStoreInterface";
import {TableCellTypes} from "../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes";
import {RouteComponentProps} from "react-router";
import GeneralTableComponent from "../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent";
import {Modal, ModalBody} from "reactstrap";

interface IProps extends RouteComponentProps {
    menuStore: IMenuStore;
}

interface IState {
    isOpen: boolean;
    isReviewOpen: boolean;
    currentItemID: string | undefined;
}

@inject('menuStore')
@observer
class ItemsScreen extends Component<IProps, IState> {
    addButton: any;
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Manage Items';
        this.state = {
            isOpen: false,
            isReviewOpen: false,
            currentItemID: undefined
        }
    }

    handleTableButtonCellClicked = (index: string, key: string) => {
        this.props.history.push(`/items/${index}/${key}`);
    };

    handleShowItemDetails = (currentItemID: string) => {
        this.setState({currentItemID, isOpen: true});
    };
    handleCloseItemDetails = () => this.setState({isOpen: false, currentItemID: undefined});
    handleShowReviews = (currentItemID: string) => {
        this.setState({currentItemID, isReviewOpen: true});
    };
    handleCloseReviews = () => this.setState({isReviewOpen: false, currentItemID: undefined});

    handelAdd = (): void => {
        this.props.history.push('/items/new');
    };

    getAddAdButton = () => {
        return {
            title: 'Add Item',
            onAdd: this.handelAdd,
        };
    };

    getAdsTableHeader = () => {
        return [
            {
                title: 'Item Name',
            },
            {
                title: 'Item Image',
            },
            {
                title: 'Item Price',
            },
            {
                title: 'Item Quantity',
            },
            {
                title: 'Edit',
            },
            {
                title: 'Item Details',
            },
            {
                title: 'Item Reviews',
            }
        ];
    };


    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'name',
            },
            {
                cellType: 'Image',
                key: 'image',
            },
            {
                cellType: 'Text',
                key: 'price',
            },
            {
                cellType: 'Text',
                key: 'quantity',
            },
            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked
            },
            {
                cellType: 'Button',
                key: 'details',
                onClick: this.handleShowItemDetails
            },
            {
                cellType: 'Button',
                key: 'reviews',
                onClick: this.handleShowReviews
            }
        ];
    };

    componentDidMount(): void {
        this.props.menuStore.mapCategoriesItemsBrands();
    }

    render() {
        const {loaded, categories: oCategories, items: oItems} = this.props.menuStore;
        if (loaded) {
            const mappedCurrentItem = oItems.filter(oItem => this.state.currentItemID === oItem.itemId)
                .map(oItem => {
                    const oCat = oCategories.filter(c => c.categoryId === oItem.categoryId);
                    return {
                        ...oItem,
                        categoryName: oCat ? oCat[0].categoryName : '',
                    };
                });
            const currentItem = oItems.filter(oItem => this.state.currentItemID === oItem.itemId);
            const mappedItemReviews = (currentItem && currentItem[0] && currentItem[0].reviews) ? currentItem[0].reviews
                .map(r => ({...r, rate: `${r.rate} / 5`})) : [];
            const mappedItemsWithCategories = oItems.map(oItem => {
                const oCat = oCategories.filter(c => c.categoryId === oItem.categoryId);
                return {
                    ...oItem,
                    categoryName: oCat ? oCat[0].categoryName : '',
                    id: oItem.itemId,
                    name: oItem.name,
                    edit: 'Edit',
                    details: 'Show Details',
                    reviews: 'Show Reviews',
                };
            });
            this.addButton = this.getAddAdButton();
            this.tableHeader = this.getAdsTableHeader();
            this.tableData = mappedItemsWithCategories;
            this.tableCellTypes = this.getAdsTableCellTypes();
            return loaded && (
                <>
                    <div>
                        <GeneralTableComponent emptyMessage='There are no items added yet'
                                               title={this.title}
                                               tableHeader={this.tableHeader}
                                               tableData={this.tableData}
                                               tableCellTypes={this.tableCellTypes}
                                               addButton={this.addButton}/>
                    </div>

                    {this.state.currentItemID &&
                    <Modal size='lg' toggle={this.handleCloseItemDetails} isOpen={this.state.isOpen}>
                        <ModalBody style={{padding: 0}}>
                            <GeneralTableComponent emptyMessage='There are no items added yet'
                                                   title='Item Details'
                                                   tableHeader={[
                                                       {
                                                           title: 'Item Description',
                                                       },
                                                       {
                                                           title: 'Item Images',
                                                       },
                                                       {
                                                           title: 'Category Name',
                                                       },
                                                       {
                                                           title: 'Brand Name',
                                                       },]}
                                                   tableData={mappedCurrentItem}
                                                   tableCellTypes={[
                                                       {
                                                           cellType: 'Text',
                                                           key: 'description',
                                                       },
                                                       {
                                                           cellType: 'Images',
                                                           key: 'images',
                                                       },
                                                       {
                                                           cellType: 'Text',
                                                           key: 'categoryName',
                                                       },
                                                       {
                                                           cellType: 'Text',
                                                           key: 'brandName',
                                                       },]}/>
                        </ModalBody>
                    </Modal>}
                    {this.state.currentItemID &&
                    <Modal size='lg' toggle={this.handleCloseReviews} isOpen={this.state.isReviewOpen}>
                        <ModalBody style={{padding: 0}}>
                            <GeneralTableComponent emptyMessage='There are no Reviews yet'
                                                   title='Item Reviews'
                                                   tableHeader={[
                                                       {
                                                           title: 'User name',
                                                       },
                                                       {
                                                           title: 'Rate',
                                                       },
                                                       {
                                                           title: 'Review',
                                                       },
                                                   ]}
                                                   tableData={mappedItemReviews}
                                                   tableCellTypes={[
                                                       {
                                                           cellType: 'Text',
                                                           key: 'name',
                                                       },
                                                       {
                                                           cellType: 'Text',
                                                           key: 'rate',
                                                       },
                                                       {
                                                           cellType: 'Text',
                                                           key: 'text',
                                                       },
                                                       {
                                                           cellType: 'Text',
                                                           key: 'brandName',
                                                       },]}/>
                        </ModalBody>
                    </Modal>}
                </>
            );
        } else {
            return null;
        }
    }
}

export default ItemsScreen;

